module.exports = __webpack_public_path__ + "static/img/4k-img.f797c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/4k-img.jpg
// module id = r6wT
// module chunks = 52